import { defaultSettings } from "../../common/General/services/fetch.services";
import { FormButton, FormLayout } from "../../common/InputForm/InputForm.d";

// Settings layout object for InputForm
export const layout: FormLayout<Record<string, any>> = [
  {
    label: "Title",
    id: "title",
    type: "text",
    defaultValue: "",
    required: true,
    className: "px-6 py-3",
    inputClass: "input-lg w-full",
    setValueAs: (title) => title.trim() || defaultSettings.title,
  },
  [
    { label: "Start Date", id: "datestart", type: "date", required: true },
    { label: "End Date", id: "dateend", type: "date", required: true },
  ],

  [
    { label: "Daily Slots", id: "dayslots", type: "number", required: true },
    { label: "Auto-fill Size", id: "autofillsize", type: "number" },
  ],

  [
    { label: "Enable Credits", id: "showcredits", type: "checkbox" },
    { label: "Auto-Report Byes", id: "autobyes", type: "checkbox" },
    { label: "Show Full Standings", id: "showstandings", type: "checkbox" },
  ],
  [
    { label: "Show Plan Menu", id: "planmenu", type: "checkbox" },
    { label: "Show Plan Events", id: "planschedule", type: "checkbox" },
    {
      label: "Show RawData",
      id: "showrawjson",
      type: "checkbox",
      inputClass: "toggle-accent",
    },
  ],
];

// Buttons prop for InputForm
export const buttons = (clickCancel: FormButton["onClick"]): FormButton[] => [
  { label: "Cancel", onClick: clickCancel },
];
